<ui-card class="card">
    <div class="container">
        <div class="top-container">
            <div class="icon-container margin-right-2">
                <img *ngIf="src" [attr.src]="src" />
            </div>
            <div class="description-container">
                <h3 class="margin-bottom-1">{{ tagline | appTranslate }}</h3>
                <div class="text-dark">
                    {{ description | appTranslate }}
                </div>
                <div *ngIf="dependencyModuleTagline" class="required-container margin-top-2">
                    <h4 class="margin-top-2">{{ 'require' | appTranslate | titlecase }}</h4>
                    <div class="flex align-items-center margin-top-1">
                        <div class="margin-right-2">
                            <img *ngIf="dependencyModuleSrc" [attr.src]="dependencyModuleSrc" />
                        </div>
                        <div>
                            <h3 class="margin-bottom-1">{{ dependencyModuleTagline | appTranslate }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ui-button
            *ngIf="!externalURL"
            class="margin-top-2"
            [routerLink]="['./embed']"
            [queryParams]="{ moduleName }"
            (click)="trackLearnMoreEvent()"
            type="outline"
            >{{ CTAText | appTranslate }}</ui-button
        >
        <ui-button
            *ngIf="externalURL"
            externalLink="true"
            [url]="externalURL"
            (click)="trackLearnMoreEvent()"
            type="outline"
            class="margin-top-2"
            >{{ CTAText | appTranslate }}</ui-button
        >
    </div>
</ui-card>
